import React from 'react';
import { ClipLoader } from 'react-spinners';
import { formatCurrency } from '../../../../utils/formatCurrency';
import { Link } from 'react-router-dom';

const BuyNowModal = ({ isLoading, onBidPlace, onClose, placeBuyAmount , totalFunds}) => {
  return (
    <dialog id="buy_now_modal" className="modal">
      <div className="modal-box dark:bg-white font-urbanist">

      {
          totalFunds <= 0 && (
            <div className="bg-[#e73f07e8] text-white text-center py-2 lg:py-[0.2vw] mb-2">
            <h2 className="text-md md:text-lg lg:text-20 font-semibold">
            You are almost set. Please {" "}
              <Link to={"/user/account/funds"} className="hover:text-blue-700 underline">
                add deposit
              </Link>{" "}
              to be able to bid
            </h2>
          </div>
          ) 
        }

        <h3 className="font-bold text-lg">Confirm Purchase</h3>
        <div className='p-2 bg-green-700 font-bold flex justify-between text-white rounded-md'>
          <span>Buy It Now </span>
          <span>{formatCurrency(placeBuyAmount)} USD</span>
        </div>
        <p className="py-4">
         {`By clicking on the 'Confirm Purchase' button below, you are committing to buy this vehicle if you are the winning bidder. All bids are final.`}
        </p>
        <div className="flex gap-x-2 justify-center">
          {isLoading ? (
            <button
              className="btn text-green-600 w-[100px] dark:bg-white hover:bg-gray-200 border-green-600"
              onClick={onBidPlace}
            >
              <ClipLoader color="#CA0000" size={20} />
            </button>
          ) : (
            <button
              className={`btn text-green-600  dark:bg-white hover:bg-gray-200 border-green-600 `}
              onClick={onBidPlace}
            >
              Confirm Purchase
            </button>
          )}
          <button
            className="btn text-red-600  dark:bg-white hover:bg-gray-200 border-red-600"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </dialog>
  );
};

export default BuyNowModal;